const themes = [
  {
    name: 'default',
    label: "Light",
    dark: false,
    color: 'royalblue'
  },
  {
    name: 'scarlet',
    label: "Scarlet",
    dark: false,
    color: '#e04e41'
  },
  {
    name: 'seafoam',
    label: "Seafoam",
    dark: false,
    color: '#177380'
  },
  {
    name: 'hotpants',
    label: "Hotpants",
    dark: false,
    color: 'hotpink'
  },
  {
    name: 'tangerine',
    label: "Tangerine",
    dark: false,
    color: '#df5815'
  },
  {
    name: 'oaken',
    label: "Oaken",
    dark: false,
    color: 'saddlebrown'
  },
  {
    name: 'majesty',
    label: "Majesty",
    dark: false,
    color: 'blueviolet'
  },
  {
    name: 'gecko',
    label: "Gecko",
    dark: false,
    color: '#4ab92f'
  },
  {
    name: 'greyscale',
    label: "Greyscale",
    dark: false,
    color: '#999999'
  },
  {
    name: 'ozark',
    label: "Ozark",
    dark: true,
    color: '#5263af'
  },
  {
    name: 'cobalt',
    label: "Cobalt",
    dark: true,
    color: '#08439b'
  },
  {
    name: 'sorcery',
    label: "Sorcery",
    dark: true,
    color: '#ae91e8'
  },
  {
    name: 'punk',
    label: "Punk",
    dark: true,
    color: '#ff5050'
  },
  {
    name: 'ember',
    label: "Ember",
    dark: true,
    color: '#f76522'
  },
  {
    name: 'riot',
    label: "Riot",
    dark: true,
    color: 'hotpink'
  },
  {
    name: 'hacker',
    label: "Hacker",
    dark: true,
    color: '#4ab92f'
  },
  {
    name: 'mastodon',
    label: "Mastodon",
    dark: true,
    color: '#282C37'
  },
  {
    name: 'pitchblack',
    label: "Pitch Black",
    dark: true,
    color: '#000'
  },
  {
    name: 'dark-greyscale',
    label: "Dark Greyscale",
    dark: true,
    color: '#666'
  },
  {
    name: 'cohost_light',
    label: "Cohost Light",
    dark: false,
    color: '#83254F'
  },
  {
    name: 'catppuccin-macchiato', // visible name
    label: "Catppuccin Macchiato", // translated-visible name
    dark: true, // whether it's a dark theme or not
    color: '#8aadf4' // main theme color
  },
  {
    name: 'catppuccin-latte',
    label: "Catppuccin Latte",
    dark: false,
    color: '#1e66f5'
  },
  {
    name: 'gruvbox-light',
    label: "Gruvbox Light",
    dark: false,
    color: '#458588'
  },
  {
    name: 'gruvbox-dark',
    label: "Gruvbox Dark",
    dark: true,
    color: '#458588'
  },
]

export { themes }
